import {createContext, useContext, useState} from "react"

const PreCruiseContext = createContext({passengers: []});

export function usePreCruiseContext() {
    const context = useContext(PreCruiseContext);
    if(!context) {
        throw new Error("usePreCruiseContext must be used within PrecruiseProvider");
    }

    return context;
}

export function PreCruiseProvider(props) {
    const [preCruiseInfo, setPreCruiseInfo] = useState({});

    return <PreCruiseContext.Provider value={{preCruiseInfo, setPreCruiseInfo}} {...props} />
}